<template lang="pug">
v-container
  .middle 
    v-card.mx-auto.rounded-lg(max-width="100%", elevation="10")
      v-card-title {{ $t('transactions') }}
      v-card-text
        v-divider
        v-container
          v-row
            v-col.col-9
              v-radio-group.nufi-radio-group(row, label="NUFI" v-model="enviroment")
                v-row                  
                  v-col
                    v-radio(v-bind:label='$t("sandbox")', light, value="sandbox").float-right
                  v-col
                    v-radio(v-bind:label='$t("production")', value="production")
            v-col.col-3(style="padding-top: 2.2em; margin-right: 0")
              a {{ $t('viewall') }}
          v-progress-linear(
            indeterminate
            color="primary"
            v-if="loading")  
          v-row(v-else)
            v-row
              v-col
                div.card.yellow.darken-1.text--white
                  v-icon(color="white") mdi-alert-circle-outline                   
                  div {{$t('callCountTotal')}}                 
                  div {{report.callCountFailed +report.callCountSuccess}}
              v-col
                div.card.green.darken-2
                  v-icon(color="white") mdi-check-circle-outline 
                  div {{$t('callCountSuccess')}}
                  div {{report.callCountSuccess}}                
              v-col
                div.card.deep-orange.darken-2
                  v-icon(color="white") mdi-alert-outline
                  div {{$t('callCountFailed')}}
                  div {{report.callCountFailed}}
          //- v-row(style="text-align:center; width:100%")
          //-     v-html(style="text-align:center; width:100%") <br /><b> {{ $t('nodatalastmonth') }} </b>

</template>
<script>
export default {
  data() {
    return {
      enviroment: 'production',
      report: {},
      loading: false
    }
  },
  created() {
    this.loading = true;
    this.$store.dispatch("reportOperationsGet", {Dates: []}).then(response => {      
      if(response.status === 200) {
        this.report = response.data;
      }
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  },
}
</script>
<style scoped>
.card {
  width: 110px;
  height: 80px;
  border-radius: 8px;
  text-align: center;
  color: white;
  padding-top: 10px;  
  margin: auto;
}
</style>
